'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _readOnlyOrEditableDecorator = require('../../../../components/form/readOnlyOrEditableDecorator');

var _readOnlyOrEditableDecorator2 = _interopRequireDefault(_readOnlyOrEditableDecorator);

var _UserNameForm = require('./UserNameForm');

var _UserNameForm2 = _interopRequireDefault(_UserNameForm);

var _UserNameReadOnly = require('./UserNameReadOnly');

var _UserNameReadOnly2 = _interopRequireDefault(_UserNameReadOnly);

require('./EditableUserName.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
// Lib
var EditableUserName = function EditableUserName(_ref) {
    var isEditing = _ref.isEditing,
        toggleEditing = _ref.toggleEditing;
    return _react2.default.createElement(
        'div',
        { className: 'EditableUserName' },
        isEditing ? _react2.default.createElement(_UserNameForm2.default, { onSubmit: toggleEditing }) : _react2.default.createElement(_UserNameReadOnly2.default, { toggleEditable: toggleEditing })
    );
};

// Styles


EditableUserName.propTypes = {
    isEditing: _propTypes2.default.bool,
    toggleEditing: _propTypes2.default.func
};

exports.default = (0, _readOnlyOrEditableDecorator2.default)(EditableUserName);


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/settings/editableUserName/EditableUserName.js
// module id = 2089
// module chunks = 0